var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-loading-container"},[_c('van-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loading-spinner",attrs:{"type":"spinner","size":"24px","color":"#1989fa"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }